import styled from "styled-components";
import { Card } from "antd";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1260px;
  display: flex;
  overflow-x: auto;

  flex-direction: column;

  h1 {
    text-align: left;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
    }
  }

  .packages {
    width: 100%;
    margin-top: 15px;
  }

  .leads {
    background: linear-gradient(135deg, #f2760a, #717a75);
  }

  .services {
    background: linear-gradient(35deg, #008037, #717a75);
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

const baseCardStyles = `
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 20px;

  .icon-wrapper {
    font-size: 48px;
    margin-bottom: 16px;
  }

  .price {
    margin-top: 16px !important;
    font-weight: 700 !important;
    font-size: 2.25rem !important; // Increased font size
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
`;

export const StyledCard = styled(Card)`
  ${baseCardStyles}
  background: white;

  .ant-card-body {
    padding: 0 !important;
  }

  .icon-wrapper {
    color: #001b22;
  }

  .price {
    color: #001b22;
  }
`;

export const BonusCard = styled(Card)`
  ${baseCardStyles}
  color: white;

  .ant-card-body {
    padding: 0 !important;
    color: white;
  }

  .icon-wrapper {
    color: #fff; // gold color for the gift icon
  }

  h4,
  .ant-typography,
  .price {
    color: white !important;
  }
`;

export const CardBuy = styled(Card)`
  ${baseCardStyles}
  background: linear-gradient(135deg, #999, #555);
  color: white;

  .ant-card-body {
    padding: 0 !important;
    color: white;
  }

  .icon-wrapper {
    color: #fff; // gold color for the gift icon
  }

  h4,
  .ant-typography,
  .price {
    color: white !important;
  }
`;
